import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import { DynamicDialogConfig, DialogService } from 'primeng/dynamicdialog';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

import { DataService, HTTPService, HelperService } from 'app/services';
import { config } from 'app/constants';
import { templateTypes } from 'app/constants/templates/template-type';

@Component({
  selector: 'app-update-appt-dialog',
  templateUrl: './update-appt-dialog.component.html',
  styleUrls: ['./update-appt-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [DialogService],
})
export class UpdateApptDialogComponent implements OnInit {
  data: any = {};
  content: string = '';
  isDataReceived: boolean = false;
  templateData: any = {};
  timezones: any = {};
  currentLang: string = 'en';

  constructor(
    public dataService: DataService,
    public dConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private httpService: HTTPService,
    private helperService: HelperService
  ) { }

  ngOnInit() {
    this.init();
  }

  async init(): Promise<void> {
    try {
      this.data = this.dConfig.data;

      const { companyId } = this.helperService.getCompany();
      const company = await this.httpService.getCompanyDetails(companyId, 'fetchTimezones=true');

      if (company && company.timezones) {
        this.timezones = company.timezones;
      }

      let customerId: string;

      if (this.data.refetch) {
        const appointment = await this.httpService.getAppointmentById(this.data._id);

        this.templateData = {
          company,
          customer: (appointment.customer && appointment.customer.customerId) || {},
          vehicle: (appointment.vehicle && appointment.vehicle.vehicleId) || {},
          appointment: {
            ...appointment,
            startDate: this.data.startDate,
            startTime: this.data.startTime,
            endDate: this.data.endDate,
            endTime: this.data.endTime,
          },
        };

        customerId = appointment.customer.customerId._id;
      } else {
        if (this.data.appointment.customer && !this.data.appointment.customer.fullName) {
          this.data.appointment.customer.fullName = this.data.customer;
        }

        this.templateData = {
          company,
          customer: this.data.appointment.customer,
          vehicle: this.data.appointment.vehicle,
          appointment: {
            ...this.data.appointment,
            startDate: this.data.startDate,
            startTime: this.data.startTime,
            endDate: this.data.endDate,
            endTime: this.data.endTime,
          },
        };

        customerId = this.data.appointment.customer.customerId;
      }

      if (this.data.currentLang) {
        this.currentLang = this.data.currentLang;
      } else if (customerId) {
        const customerLanguageRes = await this.httpService.getCustomerPreferredLanguage(customerId);
        this.currentLang = customerLanguageRes.preferredLanguage.toLowerCase();
      } else {
        this.currentLang = 'en';
      }

      const template = await this.httpService.getTemplatesByTypeLang(templateTypes.reschedule, this.currentLang);

      this.content = this.helperService.templateParser(template.contents, this.templateData, false, this.timezones, this.currentLang);

      this.isDataReceived = true;
    } catch (err) {
      this.helperService.showToaster('error', err);
    }
  }

  onClose(type: string) {
    this.dynamicDialogRef.close({
      type,
      data: {
        ...this.templateData,
        content: this.helperService.revertTemplateParsing(this.content, this.templateData),
      },
    });
  }
}
